





import React, { useState, useEffect } from 'react';

const LearningPathTFD = () => {
    const [toggle, setToggle] = useState(null);
    const [nestedToggle, setNestedToggle] = useState({});
    const [data, setData] = useState([]);

    const updateToggle = (id) => {
        setToggle(toggle === id ? null : id);
    };

    const updateNestedToggle = (nestedId) => {
        setNestedToggle((prevState) => ({
            ...prevState,
            [nestedId]: !prevState[nestedId],
        }));
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch('your-api-url');
                const data = await response.json();
                setData(data); // Update the state with fetched data
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, []);

    const listContent = [
        {
            id: 1,
            title: " ABOUT VIRTUAL SIMULATION",
            content: null,
            nestedContent: [],
        },
        {
                        id: 1,
                        title: "Introduction to Virtual Simulation",
                        content: null,
                        nestedContent: [
                            {
                                id: 1,
                                text: "•	What is Virtual Simulation? ",
                                dummyText: ["*	Definition and principles.", "*	Difference between virtual simulation, augmented reality, and virtual reality.", ],
                            },
                            {
                                id: 2,
                                text: "•	Why Virtual Simulation Matters? ",
                                dummyText: ["*	Importance in training, design, testing, and decision-making..",],
                            },
                            // {
                            //     id: 3,
                            //     text: "Nested Item 3",
                            //     dummyText: ["Virtual modeling techniques.", "Collision detection basics.", "Simulation optimization."],
                            // },
                        ],
                    },
                    {
                        id: 2,
                        title: "Types of Virtual Simulation ",
                        
                        nestedContent: [
                            {
                                id: 1,
                                text: "•	 Physical Simulation:",
                                dummyText: ["*	Simulation of physical systems using virtual models.", "*	Examples: Mechanical stress testing, aerodynamic simulations..",],
                            },
                            {
                                id: 2,
                                text: "•	 Process Simulation:",
                                dummyText: ["*	Virtual replication of industrial or business processes.", "*	Examples: Supply chain, manufacturing workflows.", ],
                            },
                            {
                                id: 3,
                                text: "•	 Interactive Simulation:",
                                dummyText: ["*	User-interactive systems for testing and training.", "	*	Examples: Flight simulators, surgical training systems", ],
                            },
                            {
                                id: 4,
                                text: "•	  Immersive Simulation:",
                                dummyText: ["*		High-level immersion through VR/AR tools.", "	*		Examples: Virtual reality training environments", ],
                            },
                        ],
                    },
                    {
                        id: 3,
                        title: "Benefits of Virtual Simulation ",
                       
                        nestedContent: [
                            {
                                id: 1,
                                text: "•	Cost Efficiency:",
                                dummyText: ["*	Reduction of physical prototyping and errors", ],
                            },
                            {
                                id: 2,
                                text: "•	Risk Reduction:",
                                dummyText: ["*	Safe testing of hazardous or complex scenarios",],
                            },
                            {
                                id: 3,
                                text: "•	Improved Learning and Training:",
                                dummyText: ["*	Enhanced engagement and practical understanding.",],
                            },
                            {
                                id: 4,
                                text: "•	Faster Iteration Cycles:",
                                dummyText: ["*	Quick testing and refinement of designs and processes.",],
                            },
                            {
                                id: 5,
                                text: "•	Global Accessibility:",
                                dummyText: ["*	Remote collaboration and access to simulated environments.",],
                            },
                        ],
                    },
                    {
                        id: 4,
                        title: "Applications of Virtual Simulation  ",
                        
                        nestedContent: [
                            {
                                id: 1,
                                text: "•	Industrial Applications:",
                                dummyText: ["*		Manufacturing: Assembly line optimization, workflow simulation.", "* 	 Robotics: Robot motion planning and task simulations.",],
                            },
                            {
                                id: 2,
                                text: "•	 Medical Applications:",
                                dummyText: ["*		Surgery training and diagnostics using virtual environments.",],
                            },
                            {
                                id: 3,
                                text: "•	Education and Training:",
                                dummyText: ["*		Simulated labs for engineering and science education.", ],
                            },
                            {
                                id: 4,
                                text: "•	 Military and Defense:",
                                dummyText: ["*			Combat and tactical training using immersive simulations..", ],
                            },
                            {
                                id: 5,
                                text: "•	Transportation:",
                                dummyText: ["*		Flight and vehicle simulators for operator training..", ],
                            },
                            {
                                id: 6,
                                text: "•	 Entertainment:",
                                dummyText: ["*				Gaming and immersive storytelling..", ],
                            },
                        ],
                    },
                    {
                        id: 5,
                        title: " Virtual Simulation Software Tools  ",
                        
                        nestedContent: [
                            {
                                id: 1,
                                text: "•		Overview of Common Tools:",
                                dummyText: ["*			Process Simulate ,Delmia,Visual Components,Robostudio,Robcaed ",],
                            },
                            {
                                id: 2,
                                text: "•		Hands-On Overview:",
                                dummyText: ["*			Quick exploration of a selected software.","*			Demonstration of basic simulation workflow.",],
                            },
                        ]
                    },
                    {
                        id: 6,
                        title: " Practical Exercise and Discussions  ",
                        
                        nestedContent: [
                            {
                                id: 1,
                                text: "•		Case Studies:",
                                dummyText: ["*			Examples of successful virtual simulation implementations",],
                            },
                            {
                                id: 2,
                                text: "•	 	Group Discussion:",
                                dummyText: ["*			Identifying areas for virtual simulation in participants' fields.",],
                            },
                            {
                                id: 3,
                                text: "•		Q&A and Wrap-Up:",
                                dummyText: ["*		Clarifying concepts and discussing future learning opportunities.", ],
                            },
                        ]
                    }
                    
                ];

    return (
        <div className="container my-5">
            {/* <h2
                className="fw-bold mb-4"
                style={{
                    color: "#000",
                    fontFamily: "Roboto",
                    width: "100%",
                    textAlign: "center",
                    marginTop: "-50px",
                }}
            >
                PROGRAM <span style={{ color: "rgb(251 145 0)" }}>OVERVIEW</span>
            </h2> */}

            <div className="list-tab" style={{ width: "100%", padding: 0 }}>
                {listContent.map(({ id, title, content, nestedContent }, index) => (
                    <div key={id} className="mb-3" style={{ width: "100%" }}>
                        <div
                            className={`p-3 rounded cursor-pointer d-flex justify-content-between align-items-center ${
                                index === 0 ? "bg-white" : "bg-light"
                            }`}
                            onClick={() => index !== 0 && updateToggle(id)}
                            style={{
                                boxShadow: index === 0 ? "none" : "0px 4px 8px rgba(0, 0, 0, 0.1)",
                                width: "100%",
                                cursor: index === 0 ? "default" : "pointer",
                            }}
                        >
                            <span
                                className={`fw-bold`}
                                style={{
                                    fontFamily: "Roboto",
                                    fontSize: index === 0 ? "19px" : "20px",
                                    color: index === 0 ? "#0072FF" : undefined,
                                }}
                            >
                                {title}
                            </span>
                            {index !== 0 && (
                                <span style={{ fontSize: "20px" }}>
                                    {toggle === id ? "-" : "+"}
                                </span>
                            )}
                        </div>
                        {/* Add line below first item */}
                        {/* {index === 0 && (
                            <div
                                style={{
                                    height: "1px",
                                    backgroundColor: "orange",
                                    width: "20%",
                                     margin: "-13px",
                                     marginLeft: '50px',
                                }}
                            ></div>
                        )} */}
                        {toggle === id && index !== 0 && (
                            <div className="mt-2 px-4">
                                {content && <p style={{ fontFamily: "Roboto" }}>{content}</p>}
                                {nestedContent.map(({ id: nestedId, text, dummyText }) => (
                                    <div key={nestedId} className="my-2">
                                        <div
                                            className="p-2 bg-white rounded cursor-pointer d-flex justify-content-between align-items-center"
                                            onClick={() => updateNestedToggle(nestedId)}
                                            style={{ border: "1px solid #ddd" }}
                                        >
                                            <span
                                                style={{
                                                    fontFamily: "Roboto",
                                                    fontSize: "18px",
                                                }}
                                            >
                                                {text}
                                            </span>
                                            <span style={{ fontSize: "18px" }}>
                                                {nestedToggle[nestedId] ? "-" : "+"}
                                            </span>
                                        </div>
                                        {nestedToggle[nestedId] && (
                                            <div className="mt-2 px-3">
                                                <ul
                                                    style={{
                                                        fontFamily: "Roboto",
                                                        color: "#555",
                                                    }}
                                                >
                                                    {dummyText.map((item, index) => (
                                                        <li key={index}>{item}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default LearningPathTFD;

